import { useCallback } from "react";

/** Deep links from One AI → in-app routes on one.atw.net (peeled paths). */
export function useDashboardOrgHref() {
  return useCallback((internalPath: string) => {
    if (/^https?:\/\//i.test(internalPath)) return internalPath;
    let path = internalPath.startsWith("/") ? internalPath : `/${internalPath}`;
    if (path.startsWith("/dashboard")) {
      path = path.replace(/^\/dashboard/, "") || "/";
    }
    return path;
  }, []);
}
